export default __webpack_public_path__ + "static/media/gw10.a0ef3d05.webp";